function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "4r8s6ddzia"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.325 11.033a6.138 6.138 0 0 0 6.132 6.132 5.964 5.964 0 0 0 3.375-1.04l3.468 3.466a1.1 1.1 0 0 0 .8.316 1.075 1.075 0 0 0 1.1-1.107 1.122 1.122 0 0 0-.309-.791l-3.443-3.45a6 6 0 0 0 1.145-3.526 6.132 6.132 0 1 0-12.265 0zm1.6 0a4.535 4.535 0 1 1 4.535 4.535 4.535 4.535 0 0 1-4.538-4.535z",
  transform: "translate(-.761 -.7)"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#4r8s6ddzia)"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9e5883e.svg";
export { ForwardRef as ReactComponent };